import { matchPath } from 'react-router-dom';

interface PrefetchableRoute {
  path: string;
  lazy: () => Promise<unknown>;
}

const prefetchableRoutes: Array<PrefetchableRoute> = [];

export const registerLazyRoute = (path: string, lazy: () => Promise<unknown>): void => {
  const hasRoute = prefetchableRoutes.some((route) => route.path === path);
  if (hasRoute) {
    return;
  }

  prefetchableRoutes.push({ path, lazy });
};

export const resetPrefetchableRoutesForTest = (): void => {
  prefetchableRoutes.length = 0;
};

const prefetchMatchingRoute = (route: PrefetchableRoute, pathname: string): boolean => {
  if (matchPath(route.path, pathname) === null) {
    return false;
  }

  void route.lazy().catch(() => undefined);

  return true;
};

/**
 * Starts downloading the code chunk for a lazy route before navigation.
 */
export const prefetchRoute = (pathname: string): void => {
  const cleanPathname = pathname.split('?')[0].split('#')[0];
  prefetchableRoutes.some((route) => prefetchMatchingRoute(route, cleanPathname));
};
